import urls from "global/constants/UrlConstants";
import { Sender, SortingConfig } from "models/interfaces";
import { getCallParams, getSearchedCallParams, makeCall } from "utils/service";

export const fetchAllSenderCount = async (searchText: string) => {
  const body = {
    searchText: searchText,
  };
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.GET_ALL_SENDERS_COUNT, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchAllSender = async (
  page: number,
  rowsPerPage: number,
  searchText: string,
  sortingParams: SortingConfig[]
) => {
  try {
    const url = `${urls.GET_SENDERS}/${page}/limit/${rowsPerPage}`;
    const body = {
      searchText: searchText,
      entitySorters: sortingParams,
    };
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const addSender = async (sender: Sender) => {
  try {
    const callParams = await getCallParams("POST", sender);
    const response = await makeCall(urls.ADD_SENDER, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const updateSender = async (sender: Sender) => {
  try {
    const callParams = await getCallParams("POST", sender);
    const response = await makeCall(urls.UPDATE_SENDER, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const deleteSender = async (id: number) => {
  try {
    const url = `${urls.DELETE_SENDER}/${id}`;
    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const verifySender = async (id: number, code: string) => {
  try {
    const url = `${urls.VERIFY_SENDER}/${id}/verify`;
    const callParams = await getSearchedCallParams("POST", code);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const resendVerificationCode = async (id: number) => {
  try {
    const url = `${urls.RESEND_VERIFICTION_CODE_SENDER}/${id}/resend`;
    const callParams = await getSearchedCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
